import {
  type CompareDataDTOBase,
  isCompareDataDTOBaseShape,
  isRecord,
  isStringArray,
} from './compare-data-utils';

const version = '1' as const;

export type CompareDataDTOV1 = CompareDataDTOBase & {
  version: typeof version;
  compare: {
    runIds: string[];
    experimentNames: string[];
  };
};

export type CompareDataDTOUpToV1 = CompareDataDTOV1;

export { version };

export function isCompareDataDTO(input: unknown): input is CompareDataDTOV1 {
  return (
    isCompareDataDTOBaseShape(input) &&
    input.version === version &&
    isRecord(input.compare) &&
    isStringArray(input.compare.runIds) &&
    isStringArray(input.compare.experimentNames)
  );
}

export function isSupportedCompareDataDTO(input: unknown): input is CompareDataDTOUpToV1 {
  return isCompareDataDTO(input);
}
